import { makeStyles } from '@material-ui/core';
import React from 'react';
import { CircularProgress, Drop } from './styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const BackDrop = () => (
  <Drop className={useStyles().backdrop} open>
    <CircularProgress color="inherit" />
  </Drop>
);
export default BackDrop;
